import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Salem() {
  const [openFaq, setOpenFaq] = useState(null);
  const navigate = useNavigate();

  const salemCards = [
    {
      icon: "🏛️",
      title: "Interesting Facts About Salem",
      desc: "Salem, known for its rich history, handloom textiles, steel industry, and lush landscapes, is one of Tamil Nadu's key cultural and economic hubs. The city's name is derived from hills, temples, and its traditional cuisine like Salem mangoes and local sweets.",
    },
    {
      icon: "🎉",
      title: "Famous Festivals in Salem",
      desc: "Salem celebrates festivals like Kanda Shasti, Navaratri, and Pongal with great devotion and cultural events. The region is also known for temple festivals, local fairs and traditional celebrations across the city and nearby towns.",
    },
    {
      icon: "🌤️",
      title: "Best Time to Visit Salem",
      desc: "The best time to visit Salem is from October to March, when the weather is pleasant and ideal for sightseeing, hill trips and outdoor activities. Temperatures ease down (June to September) bringing greenery, making Yercaud and nearby areas even more beautiful.",
    },
  ];

  const longTrips = [
    {
      title: "Yercaud Hills",
      type: "Hill Station Drive",
      distance: "35 km",
      description: "A peaceful hill station with coffee estates, viewpoints, and cool and cozy weather.",
      bgGradient: "linear-gradient(to top left, #6192fcff, #3454acff)",
      circleColor: "#F59E0B",
    },
    {
      title: "Hogenakkal",
      type: "Waterfall Getaway",
      distance: "150 km",
      description: "Famous waterfalls, coracle rides, and its scenic beauty.",
      bgGradient: "linear-gradient(to top left, #6192fcff, #3454acff)",
      circleColor: "#D97706",
    },
    {
      title: "Bangalore",
      type: "City Escape",
      distance: "210 km",
      description: "A vibrant city for shopping, food, and weekend getaways.",
      bgGradient: "linear-gradient(to top left, #6192fcff, #3454acff)",
      circleColor: "#2563EB",
    },
    {
      title: "Coimbatore",
      type: "Industrial City Trip",
      distance: "170 km",
      description: "Known for its temples, industries, shopping and nearby hill stations.",
      bgGradient: "linear-gradient(to top left, #6192fcff, #3454acff)",
      circleColor: "#8B5CF6",
    },
    {
      title: "Ooty",
      type: "Hill & Nature Escape",
      distance: "250 km",
      description: "A popular hill station with tea gardens, scenic views, and pleasant climate.",
      bgGradient: "linear-gradient(to top left, #6192fcff, #3454acff)",
      circleColor: "#8B5CF6",
    },
  ];

  const faqs = [
    {
      q: "How can I book a self drive car in Salem with Wow carz?",
      a: "Booking is simple: visit the website or app, choose your car, select a package (hourly/daily/weekly or 100 km trip), and confirm. You'll receive a booking confirmation and pickup details.",
    },
    {
      q: "What documents are required to rent a car in Salem?",
      a: "You need a valid driving license (minimum age 21 and at least 1 year of driving history) and a government-issued ID (Aadhar or Passport).",
    },
    {
      q: "Can I rent a car for a short trip within the city?",
      a: "Yes — Wow carz offers hourly, daily and weekly packages suitable for city travel, sightseeing, and short outings.",
    },
    {
      q: "Is it possible to take the rental car outside Salem?",
      a: "Yes — choose the appropriate outstation package to drive to nearby destinations like Yercaud, Hogenakkal, Ooty, and Bangalore. Check package details for kilometer limits and charges.",
    },
    {
      q: "Does Wow carz provide airport, railway station, or hotel car delivery in Salem?",
      a: "Yes — Wow carz offers 24/7 Salem Railway Station, Bus Stand pickup/drop, and doorstep delivery for hassle-free rentals.",
    },
    {
      q: "Are Wow carz rentals available for both short and long durations?",
      a: "Yes — you can book hourly packages for short trips or daily/weekly rentals for long trips and weekend getaways.",
    },
  ];

  const places = [
    {
      image: "/assets/yercaud.jpg",
      title: "Yercaud Hills",
      desc: "A beautiful hill station known for its cool climate, coffee plantations, scenic viewpoints, and nature on all sides.",
    },
    {
      image: "/assets/kottaimariamman.jpg",
      title: "Kottai Mariamman Temple",
      desc: "A famous temple in the heart of Salem, known for its history, spiritual significance, and vibrant festivals.",
    },
    {
      image: "/assets/metturdam.jpg",
      title: "Mettur Dam",
      desc: "One of the largest dams in India, offering stunning views, boating options, and a peaceful atmosphere.",
    },
    {
      image: "/assets/salemfort.jpg",
      title: "Salem Fort",
      desc: "A historic fort with panoramic views of the city, representing Salem's rich heritage.",
    },
    {
      image: "/assets/hogenakkal.jpg",
      title: "Hogenakkal Falls",
      desc: "Often called the \"Niagara of India\", a stunning waterfall, perfect for a day trip from Salem.",
    },
    {
      image: "/assets/siddharkovil.jpg",
      title: "Siddhar Kovil",
      desc: "A peaceful and spiritually significant temple dedicated to the Siddhars, located on a hill.",
    },
    {
      image: "/assets/kiliyurfalls.jpg",
      title: "Kiliyur Falls",
      desc: "A serene waterfall surrounded by lush greenery, ideal for nature lovers and short trips.",
    },
    {
      image: "/assets/sankagirifort.jpg",
      title: "Sankagiri Fort",
      desc: "A historic hill fort known for its architectural ruins and scenic views.",
    },
    {
      image: "/assets/salemmarket.jpg",
      title: "Salem Market",
      desc: "Famous for its textiles, mangoes, and local delicacies, offering a true taste of the city's culture.",
    },
  ];

  const whyCards = [
    {
      title: "Wide Range of Cars",
      text: "Perfect for city drives, road trips & long drives. Affordable self drive car rental, many options in Salem.",
    },
    {
      title: "Hassle-Free Booking",
      text: "Book your ride in minutes, pick up, drive, and enjoy — no stress, no paperwork. Easy booking & transparent pricing.",
    },
    {
      title: "24/7 Support & Delivery",
      text: "Airport, railway, bus stand pickup, and doorstep delivery. Travel easily with full support anytime.",
    },
  ];

  const mobileSliderSettings = {
    dots: true,
    responsive: [{ breakpoint: 768, settings: { arrows: false } }],
    infinite: false,
    speed: 500,
    slidesToShow: 1.1,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 font-inter">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-20">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex-shrink-0">
            <img
              onClick={() => navigate("/")}
              loading="lazy"
              style={{ height: 55, width: 160 }}
              src="https://bagzpack.s3.amazonaws.com/logo/68ea80da-f61b-4333-a4ed-ebae07c63893/IMG/1645694302682.png"
              alt="wowcarzlogo"
              className="object-cover cursor-pointer"
            />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4">
            <div className="flex items-center gap-3 mt-2 sm:mt-0">
              <a
                href="/"
                className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition"
              >
                Book Now
              </a>
              <a
                href="tel:+919844300066"
                className="inline-flex items-center gap-2 border border-gray-200 px-3 py-2 rounded-lg text-sm hover:bg-gray-100 transition"
              >
                📞 Call Us
              </a>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-8xl mx-auto px-2 sm:px-6 lg:px-8 py-10">
        {/* Hero Section */}
        <section className="relative rounded-2xl h-[500px] sm:h-[550px] lg:h-[600px] overflow-hidden">
          <img
            src="/assets/salem.jpg"
            alt="Self Drive Cars Salem"
            className="absolute inset-0 w-full h-full object-contain scale-125"
          />
          <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-center px-6 sm:px-12">
            <h2 className="text-3xl sm:text-5xl font-bold text-white mb-4 animate-fade-in">
              Self Drive Cars in Salem
            </h2>
            <p className="text-gray-200 text-base sm:text-lg mb-6 max-w-xl leading-relaxed">
              Explore Salem and nearby destinations with hassle-free self drive
              cars from Wow Carz.
            </p>
          </div>
        </section>

        {/* Explore Salem Section */}
        <section className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 p-5 m-5">
          <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-3xl p-8 sm:p-12 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6">
              Explore Salem with Wow Carz
            </h2>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              Looking for a reliable self drive car rental in Salem? Welcome to
              WowCarz, your trusted partner for affordable, flexible, and
              hassle-free self drive cars in Salem. Whether you're a local
              resident, business traveler, or tourist, WowCarz offers a wide
              range of self drive cars for rent in Salem to suit every journey.
              With WowCarz, you get the freedom to drive at your own pace — no
              timetables, no stress, no fuss. Choose from hatchbacks, sedans,
              SUVs, premium cars, and automatic vehicles, all maintained to the
              highest standards.
            </p>
          </div>
        </section>

        {/* Why Choose Wow Carz */}
        <section className="mt-16">
          <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
            Why Choose Wow Carz in Salem?
          </h3>

          {/* Desktop grid */}
          <div className="hidden md:grid grid-cols-3 gap-8 max-w-6xl mx-auto">
            {whyCards.map((card, i) => (
              <div
                key={i}
                className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
                <p className="text-gray-600">{card.text}</p>
              </div>
            ))}
          </div>

          {/* Mobile slider */}
          <div className="block md:hidden max-w-xl mx-auto">
            <Slider {...mobileSliderSettings}>
              {whyCards.map((card, i) => (
                <div key={i} className="px-2">
                  <div className="bg-white p-6 rounded-2xl shadow-lg">
                    <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
                    <p className="text-gray-600">{card.text}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </section>

        {/* Plan Your Trip */}
        <section className="py-12 sm:py-14 lg:py-16 bg-blue-200 m-5 sm:mx-6 lg:mx-10 rounded-2xl">
          <div className="max-w-7xl mx-auto text-center px-4">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-10 lg:mb-12 text-gray-900">
              Plan Your Trip to Salem
            </h2>

            {/* Desktop Grid */}
            <div className="hidden sm:grid grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
              {salemCards.map((card, i) => (
                <div
                  key={i}
                  className="bg-white p-6 sm:p-7 lg:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300"
                >
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 text-xl sm:text-2xl">
                    {card.icon}
                  </div>
                  <h3 className="text-lg sm:text-xl font-semibold mb-3">
                    {card.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                    {card.desc}
                  </p>
                </div>
              ))}
            </div>

            {/* Mobile Carousel */}
            <div className="sm:hidden">
              <Slider
                dots={true}
                infinite={true}
                speed={500}
                slidesToShow={1}
                responsive={[{ breakpoint: 768, settings: { arrows: false } }]}
                slidesToScroll={1}
              >
                {salemCards.map((card, i) => (
                  <div key={i} className="px-3">
                    <div className="bg-white p-6 rounded-2xl shadow-md">
                      <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 text-2xl">
                        {card.icon}
                      </div>
                      <h3 className="text-lg font-semibold mb-3">
                        {card.title}
                      </h3>
                      <p className="text-gray-700 text-sm">{card.desc}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </section>

        {/* Top Places */}
        <section className="mt-12">
          <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
            Top Places to Visit in Salem
          </h3>
          <p className="text-gray-600 mb-6 text-center">
            Explore historic temples, scenic hills, waterfalls, and cultural
            spots with your Wow Carz ride.
          </p>

          {/* Desktop grid */}
          <div className="hidden sm:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
            {places.map((place) => (
              <article
                key={place.title}
                className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 hover:border-blue-300 transition-transform duration-300 transform hover:-translate-y-2 hover:scale-105 text-center"
              >
                <div className="overflow-hidden rounded-xl mb-4">
                  <img
                    className="w-48 h-48 object-cover rounded-xl mx-auto transition-transform duration-300 transform hover:scale-110"
                    src={place?.image}
                    alt={place.title}
                  />
                </div>
                <h4 className="font-semibold text-xl text-gray-800 mb-2">
                  {place.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {place.desc}
                </p>
              </article>
            ))}
          </div>

          {/* Mobile slider */}
          <div className="block sm:hidden max-w-xl mx-auto">
            <Slider {...mobileSliderSettings}>
              {places.map((place) => (
                <div key={place.title} className="px-2">
                  <article className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="overflow-hidden rounded-xl mb-4">
                      <img
                        className="w-48 h-48 object-cover rounded-xl mx-auto"
                        src={place?.image}
                        alt={place.title}
                      />
                    </div>
                    <h4 className="font-semibold text-xl text-gray-800 mb-2">
                      {place.title}
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {place.desc}
                    </p>
                  </article>
                </div>
              ))}
            </Slider>
          </div>
        </section>

        {/* Nearby Long Trips */}
        <section className="mt-16">
          <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
            Nearby Long Trips (250 km – 350 km)
          </h3>
          <p className="text-gray-600 mb-6 text-center">
            Plan exciting weekend getaways with your Wow Carz rental from Salem.
          </p>

          {/* Desktop grid */}
          <div className="hidden lg:grid grid-cols-5 gap-8 px-4">
            {longTrips.map((trip) => (
              <div
                key={trip.title}
                className="card m-auto text-gray-300 w-[clamp(260px,80%,300px)] hover:brightness-90 transition-all cursor-pointer group rounded-lg overflow-hidden relative border-r-2 border-t-2 border-gray-900 m-4"
                style={{
                  background: trip.bgGradient,
                  minHeight: "300px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div className="px-8 py-10">
                  <div className="uppercase text-white font-bold text-xl">
                    {trip.title}
                  </div>
                  <div className="text-gray-400 text-white mt-8">
                    <p className="font-bold text-white">{trip.distance}</p>
                    <p>{trip.description}</p>
                  </div>
                </div>
                <div className="h-2 w-full bg-gradient-to-l via-yellow-500 group-hover:blur-xl blur-2xl m-auto rounded transition-all absolute bottom-0"></div>
                <div className="h-0.5 group-hover:w-full bg-gradient-to-l via-yellow-950 group-hover:via-yellow-500 w-[70%] m-auto rounded transition-all"></div>
              </div>
            ))}
          </div>

          {/* Mobile slider */}
          <div className="block lg:hidden max-w-xl mx-auto">
            <Slider {...mobileSliderSettings}>
              {longTrips.map((trip) => (
                <div key={trip.title} className="px-2">
                  <div
                    className="card text-gray-300 w-full hover:brightness-90 transition-all cursor-pointer group rounded-lg overflow-hidden relative border-r-2 border-t-2 border-gray-900 m-4"
                    style={{
                      background: trip.bgGradient,
                      minHeight: "300px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="px-8 py-10">
                      <div className="uppercase text-white font-bold text-xl">
                        {trip.title}
                      </div>
                      <div className="text-gray-300 text-white uppercase tracking-widest">
                        {trip.type}
                      </div>
                      <div className="text-gray-400 text-white mt-8">
                        <p className="font-bold text-white">{trip.distance}</p>
                        <p>{trip.description}</p>
                      </div>
                    </div>
                    <div className="h-2 w-full bg-gradient-to-l via-yellow-500 group-hover:blur-xl blur-2xl m-auto rounded transition-all absolute bottom-0"></div>
                    <div className="h-0.5 group-hover:w-full bg-gradient-to-l via-yellow-950 group-hover:via-yellow-500 w-[70%] m-auto rounded transition-all"></div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="mt-20">
          <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
            Frequently Asked Questions
          </h3>
          <div className="max-w-4xl mx-auto">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="border-b border-gray-200 py-4 cursor-pointer"
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
              >
                <h4 className="text-lg font-medium flex justify-between items-center">
                  {faq.q}{" "}
                  <span className="ml-4">{openFaq === i ? "−" : "+"}</span>
                </h4>
                {openFaq === i && (
                  <p className="text-gray-600 mt-2">{faq.a}</p>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="mt-16 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 text-white p-8 rounded-3xl flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="text-center sm:text-left">
            <h4 className="text-2xl font-semibold">
              Ready to Start Your Journey?
            </h4>
            <p className="text-sm mt-2 text-blue-100">
              Explore Salem's scenic hills, temples and nearby destinations with
              Wow Carz today.
            </p>
          </div>
          <div className="flex gap-3">
            <a
              href="/"
              className="bg-white text-blue-600 px-6 py-3 rounded-lg font-medium hover:bg-blue-100 transition"
            >
              Book Now
            </a>
            <a
              href="tel:+919844300066"
              className="border border-white px-6 py-3 rounded-lg hover:bg-white hover:text-blue-600 transition"
            >
              Call Us
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-10 text-center text-sm text-gray-500">
          © {new Date().getFullYear()} Wow Carz — All rights reserved
        </footer>
      </main>
    </div>
  );
}

export default Salem;
